export const CheckboxItem = ({
  slug,
  title,
  checked,
  onChange,
}: {
  slug: string;
  title: string;
  checked: boolean;
  onChange: () => void;
}) => (
  <label
    data-testid={`filter-option-${slug}`}
    className="group flex cursor-pointer items-center py-2 select-none"
  >
    <input
      type="checkbox"
      checked={checked}
      onChange={onChange}
      className="peer sr-only"
    />
    <div
      className={`flex h-5 w-5 items-center justify-center rounded border transition-all ${
        checked
          ? 'bg-theme-action-primary border-theme-action-primary'
          : 'border-gray-300 bg-white'
      }`}
    >
      {checked && (
        <svg
          className="h-3.5 w-3.5 text-white"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polyline points="20 6 9 17 4 12" />
        </svg>
      )}
    </div>
    <span
      className={`ml-3 text-[15px] ${
        checked
          ? 'text-theme-action-primary font-medium'
          : 'text-theme-dark-deep'
      }`}
    >
      {title}
    </span>
  </label>
);
